import styled from "styled-components";

import { Typography } from "@mui/material";
import Colors from "@constants/Colors";

export const CustomTypographyH5 = styled(Typography)`
  &.MuiTypography-root {
    font-family: Ringside Regular-Bold;
    font-style: normal;
    font-weight: 400;
    color: ${Colors.neutralblack};
    font-size: 14px;
    line-height: 20px;
  }
`;

export const CustomTypographyH6 = styled(Typography)`
  &.MuiTypography-root {
    font-family: Ringside Regular-Book;
    font-style: normal;
    font-weight: 325;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: ${Colors.neutral_gray_500};
  }
`;
